export const httpPoint = {
    user: '/users/',
    game: '/game/',
    order: '/order/',
    balance: '/balance/',
    search: '/search/',
    supportchat: '/supportchat/'
}

export const boxStyles = {
    backgroundColor: 'background.paper',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
}






 
